import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox } from './FieldLayoutBox'
import { CustomInput } from 'reactstrap'
import { FieldValueFormatter, FieldValueParser } from './FieldValueConverters'
import _ from 'common-tools/LodashHelper'

class RadioListBoxClass extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    options: pt.array.isRequired,
    textProp: pt.string.isRequired,
    valueProp: pt.string.isRequired,
    queryFieldSetup: pt.shape({
      Name: pt.string,
      Operator: pt.string,
      Group: pt.string
    }),
    inline: pt.bool.isRequired
  })

  static defaultProps = {
    options: [],
    textProp: 'Text',
    valueProp: 'Value',
    inline: false
  }

  renderOptions (inline, options, textProp, valueProp, fieldProps) {
    const { value, onChange, name } = fieldProps

    return (
      <div>
        {_.map(options, (o, i) => {
          const valuePropValue = o[valueProp || 'Value']
          const textPropValue = o[textProp || 'Text']

          return <CustomInput key={valuePropValue} type='radio' checked={valuePropValue === value} id={`${name}_${i}`} name={name} onChange={onChange} label={textPropValue || valuePropValue}
            value={valuePropValue} inline={inline} />
        })}
      </div>
    )
  }

  render () {
    const { inline, options, textProp, valueProp, ...rest } = this.props

    return (
      <FieldLayoutBox {...rest}>
        {(fieldProps) => this.renderOptions(inline, options, textProp, valueProp, fieldProps) }
      </FieldLayoutBox>
    )
  }
};

export const RadioListBox = ({ parse, format, fieldType, ...rest }) => { return <Field parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={RadioListBoxClass} /> } // eslint-disable-line
export default RadioListBox
